<script setup lang="ts">
  import { computed } from 'vue'

  interface Props {
    label?: string
    value?: string
  }

  const props = withDefaults(defineProps<Props>(), {
    label: '',
    value: '',
  })

  const modelValue = defineModel<string>()

  const isActive = computed(() => modelValue.value === props.value)

  const handleClick = () => {
    modelValue.value = props.value
  }
</script>

<template>
  <div class="base-radio" @click="handleClick">
    <div class="base-radio__tumbler" :class="{ 'base-radio__tumbler--active': isActive }"></div>
    <div class="base-radio__label">
      {{ label }}
    </div>
  </div>
</template>

<style scoped>
  .base-radio {
    display: flex;
    align-items: center;
    height: 40px;
    cursor: pointer;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
  }

  .base-radio + .base-radio {
    margin-inline-start: 32px;
  }

  .base-radio__tumbler {
    width: 24px;
    height: 24px;
    border: 1px solid #526c8233;
    border-radius: 53px;
    margin-inline-end: 12px;
    position: relative;
  }

  .base-radio__tumbler--active {
    border: 2px solid #6568f4;
  }

  .base-radio__tumbler--active::after {
    content: '';
    height: 14px;
    width: 14px;
    display: block;
    border-radius: 28px;
    position: absolute;
    left: 50%;
    top: 50%;
    background: #6568f4;
    transform: translate(-50%, -50%);
  }
</style>
